"use client"

import { ThemeProvider } from "@/components/theme-provider"

/**
 * Landing stays in dark theme regardless of system preference — uses design tokens only.
 */
export function MarketingThemeShell({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      forcedTheme="dark"
      enableSystem={false}
      disableTransitionOnChange
    >
      <div className="marketing-page-root relative isolate min-h-screen min-w-0 overflow-x-clip bg-background text-foreground antialiased">
        <div className="relative z-[1] min-w-0">{children}</div>
      </div>
    </ThemeProvider>
  )
}
